/**
 * Area color mapping for OoT locations.
 */
export const AREA_COLORS: Record<string, string> = {
  Forest: '#048605',
  'Death Mountain': '#b53336',
  Kakariko: '#c479c8',
  Zora: '#5181fe',
  Desert: '#e5ad08',
  Hyrule: '#23b4a6',
  Special: '#9ca3af',
};

export function getAreaColor(areaName: string): string {
  return AREA_COLORS[areaName] ?? '#9ca3af';
}

/** Tailwind classes for area colors */
export const AREA_BG_CLASSES: Record<string, string> = {
  Forest: 'bg-green-700',
  'Death Mountain': 'bg-red-700',
  Kakariko: 'bg-purple-600',
  Zora: 'bg-blue-600',
  Desert: 'bg-yellow-600',
  Hyrule: 'bg-teal-600',
};

export const AREA_TEXT_CLASSES: Record<string, string> = {
  Forest: 'text-green-400',
  'Death Mountain': 'text-red-400',
  Kakariko: 'text-purple-400',
  Zora: 'text-blue-400',
  Desert: 'text-yellow-400',
  Hyrule: 'text-teal-400',
};
